import React from "react";

function Media() {
  return <div>Media page</div>;
}

export default Media;
